import React from 'react';
import { Outlet } from 'react-router-dom';
import AppShell from '../components/AppShell';
import ImprovementBanner from '../components/ImprovementBanner';

/**
 * AuthenticatedLayout - Single, persistent layout for all authenticated pages
 * 
 * This component ensures:
 * - AppShell (including Sidebar) is mounted once and never remounted
 * - Only the main content area changes on navigation
 * - Sidebar scroll position is preserved across navigation
 * 
 * Note: Scroll-to-top behavior is handled by ScrollToTopContent component
 * which only affects the main content area, not the sidebar.
 */
const AuthenticatedLayout = () => {
  return (
    <AppShell>
      <Outlet />
      <ImprovementBanner />
    </AppShell>
  );
};

export default AuthenticatedLayout;
